import Backpack from './Backpack';

export default Backpack;
